import { Theme } from '@spoiler-alert/ui-library';
import PropTypes from 'prop-types';
import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  badge: {
    border: `1.5px solid ${Theme.primaryButtonColor}`,
    backgroundColor: Theme.green5,
    color: Theme.green,
    fontSize: '14px',
    fontWeight: 'bold',
    borderRadius: '100px',
    padding: '4px 16px 4px 54px',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    lineHeight: '24px',
  },
  icon: {
    position: 'absolute',
    top: 'calc(50% - 20px)',
    left: '16px',
  },
});

const ColorBadgeWithIcon = ({ children, icon, badgeClass }) => {
  const Icon = icon;
  const classes = useStyles();
  return (
    <div className={`${classes.badge} ${badgeClass}`}>
      <span data-element="status-badge" style={{ padding: 0 }}>
        {children}
      </span>
      {icon && <Icon className={classes.icon} />}
    </div>
  );
};

ColorBadgeWithIcon.propTypes = {
  children: PropTypes.node.isRequired,
  icon: PropTypes.elementType,
  badgeClass: PropTypes.object,
};

export default ColorBadgeWithIcon;
